export const SAVINGS_GOAL_CATEGORIES = {
  HOUSE: "HOUSE",
  CAR: "CAR",
  FUTURE_EDUCATION: "FUTURE_EDUCATION",
  DEBT: "DEBT",
  RETIREMENT: "RETIREMENT",
} as const;

export type SavingsGoalCategory =
  (typeof SAVINGS_GOAL_CATEGORIES)[keyof typeof SAVINGS_GOAL_CATEGORIES];

export const SAVINGS_GOAL_SELECT_DISPLAY: Record<SavingsGoalCategory, string> = {
  [SAVINGS_GOAL_CATEGORIES.HOUSE]: "House",
  [SAVINGS_GOAL_CATEGORIES.CAR]: "Car",
  [SAVINGS_GOAL_CATEGORIES.FUTURE_EDUCATION]: "Future Education",
  [SAVINGS_GOAL_CATEGORIES.DEBT]: "Debt",
  [SAVINGS_GOAL_CATEGORIES.RETIREMENT]: "Retirement",
};

export const SAVINGS_GOAL_DISPLAY: Record<SavingsGoalCategory, string> = {
  [SAVINGS_GOAL_CATEGORIES.HOUSE]: "for Your House",
  [SAVINGS_GOAL_CATEGORIES.CAR]: "for Your Car",
  [SAVINGS_GOAL_CATEGORIES.FUTURE_EDUCATION]: "for Your Future Education",
  [SAVINGS_GOAL_CATEGORIES.RETIREMENT]: "for Your Retirement",
  [SAVINGS_GOAL_CATEGORIES.DEBT]: "towards Debt",
};

export const SAVINGS_GOAL_OPTIONS = Object.values(SAVINGS_GOAL_CATEGORIES);
